import React from "react";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
import "../src/style/scss/main.scss";
import "../src/customStyle.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/fonts/feather/css/iconfont.css";
import { createRoot } from "react-dom/client";
import "./i18n"; // Import the i18n config
import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import ModernTheme, { initializeModernTheme } from "./core/common/ui/ModernTheme";
import "./style/scss/modern/main.scss";
import PageLoader from "./core/loader";
import AllRoutes from "./Router/router.jsx";
import UpdateBanner from "./core/common/update-banner/UpdateBanner.jsx";

window.bootstrap = bootstrap;
initializeModernTheme();

const rootElement = document.getElementById("root");
let persistor = persistStore(store);

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={<PageLoader/>} persistor={persistor}>
          <BrowserRouter basename={base_path}>
            <ModernTheme><AllRoutes /></ModernTheme>
            <UpdateBanner />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}
